import React from 'react';
import SMFormFieldBaseView from 'components/dashboard/form/SMFormFieldBaseView';

class SMFormValidationMessage extends SMFormFieldBaseView {
  
  renderErrorIcon() {
    if (this.props.withIcon) {
      return <i className="fa fa-exclamation-circle"></i>;
    }
  }
  
  render() {
    const errorClassName = this.errorTextClassName(this.props.options.className, this.props.errorText);
    
    if (this.props.errorText != null && this.props.errorText != "") {
      return (
        <p className={errorClassName}>
          {this.renderErrorIcon()}
          {this.props.errorText}
        </p>
      );
    } else {
      return null;
    }
  }
}

SMFormValidationMessage.defaultProps = {
  withIcon: false,
  options: {
    className: "mt5",
  }
};
export default SMFormValidationMessage;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMFormValidationMessage.jsx